import type { MouseEventHandler } from "react";

import { Badge } from "@similarweb/ui-components";

import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import { i18nFilter, translate } from "app/filters/i18nFilter";

const TopicChangesTag = (props: { onMouseEnter: MouseEventHandler }) => {
    return (
        <PlainTooltip text={i18nFilter()("si.savedSearch.tag.topic-changes.intent-tooltip")}>
            <div onMouseEnter={props.onMouseEnter}>
                <Badge type="alpha">{translate("si.savedSearch.tag.topic-changes")}</Badge>
            </div>
        </PlainTooltip>
    );
};

export default TopicChangesTag;
